/**
 * Source: Figma "RM V2 Library (MUI v7.2.0)" — Theme page, `Variables Design Sheet` → `Card - _primitive`.
 * https://www.figma.com/design/kMeScGRhmLq2l22M2ZkmiE/RM-V2-Library--MUI-v7.2.0-?node-id=11207-164308
 * Verified with design (IL - 05/08/2026)
 */

// pink.50, pink.100, pink.200, red.50, red.100, red.200, amber.100, amber.200, cyan.50, cyan.100, cyan.200, lightBlue.300, purple.50, purple.100, purple.200.
export const colorPrimitives = {
  base: {
    white: "#ffffff",
    black: "#000000",
  },
  amber: {
    50: "#fff8eb",
    100: "#FFF0D4",
    200: "#FCD792",
    300: "#ffb645",
    400: "#ff9e20",
    500: "#fc8c14",
    600: "#f97907",
    700: "#dd5502",
    800: "#942a0c",
    900: "#6b1e0a",
  },
  blue: {
    50: "#f5f9ff",
    100: "#e0ecff",
    200: "#bdd6ff",
    300: "#8fb8ff",
    400: "#6b9cff",
    500: "#427bff",
    600: "#315bf5",
    700: "#1e41bd",
    800: "#11308a",
    900: "#00022b",
  },
  cyan: {
    50: "#F0FDFF",
    100: "#D7F6FA",
    200: "#B3EBF2",
    300: "#4dd0e1",
    400: "#26c6da",
    500: "#00bcd4",
    600: "#00acc1",
    700: "#0097a7",
    800: "#00838f",
    900: "#006064",
  },
  gray: {
    50: "#f6f7f8",
    100: "#eaecf0",
    200: "#ced4db",
    300: "#acb7c2",
    400: "#929fb0",
    500: "#758294",
    600: "#5b6778",
    700: "#3d4857",
    800: "#2b3340",
    900: "#171c24",
  },
  green: {
    50: "#f5fcf5",
    100: "#e9f7e9",
    200: "#cbedcc",
    300: "#9cd99e",
    400: "#69bf6c",
    500: "#43a047",
    600: "#348538",
    700: "#2b6a2e",
    800: "#214d23",
    900: "#042108",
  },
  lightBlue: {
    50: "#eff9ff",
    100: "#def1ff",
    200: "#B3E2FC",
    300: "#75d2ff",
    400: "#2cbcff",
    500: "#00a8ff",
    600: "#0084d9",
    700: "#0064a6",
    800: "#004d7d",
    900: "#003659",
  },
  orange: {
    50: "#fff4ed",
    100: "#ffe5d4",
    200: "#ffc8a8",
    300: "#ffa170",
    400: "#ff733d",
    500: "#f75707",
    600: "#cf4500",
    700: "#ad3400",
    800: "#822700",
    900: "#360d02",
  },
  pink: {
    50: "#FFF5F8",
    100: "#FFE5EE",
    200: "#FFC4D8",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
  },
  purple: {
    50: "#F9F5FF",
    100: "#F0E8FF",
    200: "#DCCEF5",
    300: "#9575cd",
    400: "#7e57c2",
    500: "#673ab7",
    600: "#5e35b1",
    700: "#512da8",
    800: "#4527a0",
    900: "#311b92",
  },
  red: {
    50: "#FEF4F4",
    100: "#FEE2E2",
    200: "#FFBDBD",
    300: "#fc8389",
    400: "#ff5762",
    500: "#f02e3a",
    600: "#d41724",
    700: "#ab111e",
    800: "#7a0a19",
    900: "#3b040d",
  },
} as const;

export type ColorHue = Exclude<keyof typeof colorPrimitives, "base">;
export type ColorShade = keyof (typeof colorPrimitives)["blue"];
